<template>
    <el-dialog
        :title="'打印模板选择'"
        :width="'750px'"
        :visible="visible"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="true"
        :before-close="beforeClose"
        :custom-class="'dispatchNewPrintDialog'"
        top="5vh"
    >
        <div class="print-wrapper" v-if="printListLength">
            <el-row>
                <el-col :span="8" v-for="(item, index) in printList" :key="index" class="container">
                    <p class="title">{{ item.styleAttributeName }}</p>
                    <el-scrollbar class="scrollbar">
                        <div class="templateList">
                            <el-radio-group v-model="item.checkedTemplate">
                                <el-radio
                                    v-for="templateItem in item.templateList"
                                    :key="templateItem.templateCode"
                                    :label="templateItem.templateCode"
                                    @click.native.prevent="handleRadioChange(item, templateItem.templateCode)"
                                    class="radio-item"
                                >
                                {{ templateItem.templateName }}
                                <p
                                    v-if="item.checkedTemplate === templateItem.templateCode"
                                    @click.stop.prevent="handlePreview(templateItem.templateCode)"
                                    class="preview-text"> 预览</p>
                                </el-radio>
                            </el-radio-group>
                        </div>
                    </el-scrollbar>
                </el-col>
            </el-row>
        </div>
        <div class="text-container" v-else>
            <p>提示：当前发车单没有匹配的打印模板，请跳转到老版打印界面进行打印或联系城配IT产品经理进行配置。</p>
        </div>
        <div slot="footer" class="dialog-footer">
            <div>
                <el-checkbox v-model="isRemember" class="checkbox">记住我的选择</el-checkbox>
                <el-button type="primary" @click="openOldPrintDialog" class="back-to">跳转到老版打印界面</el-button>
            </div>
            <div>
                <el-button @click="beforeClose">取 消</el-button>
                <el-button type="primary" @click="handlePrint" :disabled="!printListLength" :loading="btnLoading">打 印</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { queryTemplate } from '@/modules/transport/otp/api/performanceDispatchNewPrint.js';
import { getLocalStorage, setLocalStorage, handleDispatchPrint, checkedDataValidated } from './util.js';
export default {
    name: 'DispatchNewPrintDialog',
    props: {
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            printList: [],
            isRemember: true,
            visible: false,
            btnLoading: false
        };
    },
    computed: {
        printListLength () {
            return this.printList.length;
        }
    },
    async mounted () {
        this.getRememberFlag();
        await this.queryTemplate();
        this.initRadioStatus();
        this.visible = true;
    },
    methods: {
        // 从缓存中读取 记住我的选择 状态, 默认开启
        getRememberFlag () {
            this.isRemember = getLocalStorage('isRemember') === null ? true : getLocalStorage('isRemember');
        },
        // 匹配打印模板
        queryTemplate () {
            this.loading = true;
            return queryTemplate({ dispatchNo: this.componentsData.dispatchNo }).then(res => {
                if (res && +res.code === 0) {
                    this.printList = res.data || [];
                }
            }).catch(() => { });
        },
        /**
         * @description 初始化各打印大类下的默认选中模板
         *  接口返回printList数据结构：
         *  [{ styleAttributeCode：'DELIVERY_ORDER', styleAttributeName: '配送单',
         *  templateList: [{templateCode: 'tms_psd_custNo', templateName: '配送单-城配'}] }]
         *  缓存printTemplate数据结构：
         *  [{ styleAttributeCode: 'DELIVERY_ORDER', styleAttributeName:'DELIVERY_ORDER', checkedTemplate: 'tms_psd_custNo' }]
         */
        initRadioStatus () {
            if (!this.printList.length) return;
            this.printList.forEach(item => this.$set(item, 'checkedTemplate', ''));
            if (getLocalStorage('isRemember')) {
                const storagePrintTemplate = getLocalStorage('printTemplate');
                this.printList.forEach(currentPrintType => {
                    const storagePrintType = storagePrintTemplate.find(storageItem => storageItem.styleAttributeCode === currentPrintType.styleAttributeCode);
                    if (storagePrintType) {
                        const storagePrintTemplate = currentPrintType.templateList.find(templateItem => templateItem.templateCode === storagePrintType.checkedTemplate);
                        if (storagePrintTemplate) {
                            currentPrintType.checkedTemplate = storagePrintType.checkedTemplate;
                        }
                    }
                });
            } else {
                this.printList[0].checkedTemplate = this.printList[0].templateList[0].templateCode;
            }
        },
        // 勾选时触发事件
        handleRadioChange (item, currentTemplateCode) {
            // 若当前选中值与之前选中的值相同，则取消选中
            item.checkedTemplate = item.checkedTemplate === currentTemplateCode ? '' : currentTemplateCode;
            // 选中当前打印大类下的打印单时，其他大类下选中清空（实现单选）
            this.printList.filter(printType => printType.styleAttributeName !== item.styleAttributeName).forEach(v => {
                v.checkedTemplate = '';
            });
        },
        // 跳转到老版打印界面
        openOldPrintDialog () {
            this.$emit('openOldPrintDialog', this.componentsData);
        },
        // 预览
        handlePreview (templateCode) {
            const params = {
                dispatchNo: this.componentsData.dispatchNo,
                templateCode: templateCode,
                customerOrderNoList: this.componentsData.customerOrderNos
            };
            handleDispatchPrint(this, params); // 处理打印逻辑
        },
        // 打印按钮
        handlePrint () {
            const isValidated = checkedDataValidated(this.printList);
            if (!isValidated) return;
            this.handleStorage();
            const checkedTemplateList = this.printList.filter(v => v.checkedTemplate).map(v => v.checkedTemplate).join();
            const params = {
                dispatchNo: this.componentsData.dispatchNo,
                templateCode: checkedTemplateList,
                customerOrderNoList: this.componentsData.customerOrderNos
            };
            handleDispatchPrint(this, params); // 处理打印逻辑
        },
        // 缓存逻辑处理
        handleStorage () {
            setLocalStorage('isRemember', this.isRemember);
            if (!this.isRemember) return;
            const storagePrintObject = this.printList.filter(v => Boolean(v.checkedTemplate)).map((item) => {
                return {
                    styleAttributeCode: item.styleAttributeCode,
                    styleAttributeName: item.styleAttributeName,
                    checkedTemplate: item.checkedTemplate
                };
            });
            setLocalStorage('printTemplate', storagePrintObject);
        },
        beforeClose () {
            this.$emit('update:isShowNewPrintDialog', false);
        }
    }
};
</script>

<style lang="less">
.dispatchNewPrintDialog {
    .text-container {
        // text-align: center;
        font-size: 13px;
        color: red;
    }
    .title {
        display: inline-block;
        // color: #00BCBF;
        border-bottom: 1px solid #EBEEF5;
        font-size: 14px;
        margin: 0px 0px 10px 5px;
        padding-bottom: 2px;
        // padding: 0px 5px 3px 5px;
    }
    .container {
        padding-right: 10px;
    }
    .templateList{
        padding-left: 5px;
    }
    .scrollbar{
        height: 120px;
        margin-bottom: 20px;
    }
    .is-horizontal {
        display: block;
    }
    /* 不展示水平滚动条 */
    /deep/ .is-horizontal {
        display: none;
    }
    .el-radio-group {
        width: 100%;
    }
    .radio-item {
        display: block;
        line-height: 24px;
        .preview-text{
            display: inline-block;
            // color: rgb(255, 199, 0);
            font-weight: 900;
            margin: 0px 0px 0px 6px;
        }
    }
    .radio-item .el-radio__inner {
        border-radius: 0px;
    }
    // 单选按钮实现对勾样式
    .radio-item .el-radio__input.is-checked .el-radio__inner::after {
        content: '';
        width: 8px;
        height: 3px;
        border: 2px solid white;
        border-top: transparent;
        border-right: transparent;
        text-align: center;
        display: block;
        position: absolute;
        top: 2px;
        left: 1px;
        transform: rotate(-45deg);
        border-radius: 0px;
        background: none;
    }
    .el-dialog__body {
        min-height: 100px;
        max-height: 500px;
        overflow: auto;
    }
    .dialog-footer {
        display: flex;
        justify-content: space-between;
    }
}
</style>
